import { Type } from 'vue-models'

export default class TextField extends Type {
  out () {
    if (typeof this.value === 'undefined' || this.value === null) {
      return undefined
    } else {
      return this.value.toString()
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/types/TextField.js